import { DefaultError, useMutation } from '@tanstack/react-query';
import { getExternalAuthRedirected } from 'shared/services/backend-api';
import { ExternalConnectionsProviders } from 'shared/types/external-connections';

export const useRedirectToExternalAuthMutation = () =>
  useMutation<void, DefaultError, ExternalConnectionsProviders>({
    mutationFn: async (provider) => await getExternalAuthRedirected(provider),
  });
